import { render, staticRenderFns } from "./ProfSalonLink.vue?vue&type=template&id=ff77ea56&scoped=true"
import script from "./ProfSalonLink.vue?vue&type=script&lang=js"
export * from "./ProfSalonLink.vue?vue&type=script&lang=js"
import style0 from "./ProfSalonLink.vue?vue&type=style&index=0&id=ff77ea56&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff77ea56",
  null
  
)

export default component.exports